export default ['JsonRPCService', 'JobService', (JsonRPCService, JobService) => {

    return {
        findJobByJobNumber: (renewalNumber) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'findJobByJobNumber', [renewalNumber]);
        },
        getRenewalSummary: (renewalNumber) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getJobSummaryCount', [renewalNumber]);
        },
        getNotesForRenewal: (renewalNumber) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getNotesForRenewal', [renewalNumber]);
        },
        createNoteForRenewal: (renewalNumber, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'createNoteForRenewal', [renewalNumber, noteDTO]);
        },
        getDocumentsForRenewal: (renewalNumber) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getDocumentsForRenewal', [renewalNumber]);
        },
        referToUnderwriter: (renewalNumber, noteBody) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'referToUnderwriter', [renewalNumber, noteBody]);
        },
        withdrawRenewalByRenewalNumber: (renewalNumber) => {
            return JobService.withdrawJobByJobNumber(renewalNumber);
        },
        markRenewalNotTaken: (renewalNumber) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'markRenewalNotTaken', [renewalNumber]);
        },
        markRenewalNonRenew: (renewalNumber) => {
            return JsonRPCService.send('pc', 'gateway/renewal', 'markRenewalNonRenew', [renewalNumber]);
        }
    };
}];